//packages
import React, { useState, useEffect } from "react";
import { withRouter, useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import NotificationContainer from "./NotificationContainer";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";
import { openFailDialog } from "../../Redux/Actions/PopupActions";
// Utils
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
//Material Ui
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import Badge from "@material-ui/core/Badge";
import Avatar from "@material-ui/core/Avatar";
import {
  FaPowerOff,
  FaUserCog,
  FaRegEdit,
  FaUser,
  FaSchool,
  FaKey,
  FaTimes,
  FaDatabase,
  FaVideo,
  FaCut,
} from "react-icons/fa";
import { AiFillWarning } from "react-icons/ai";
import blankProfile from "./images/blank-profile.png";
// Assets
import UploadIcon from "../../assets/images/UploadIcon.png";
import {
  schoolAdminList,
  coachesList,
  athleteList,
} from "../../data/SchoolAdminPortalData";
import "../schoolAdminPortal/schoolAdmin.css";
import userService from "../../services/user.service";
import { useDispatch, useSelector } from "react-redux";
import {
  userRoleDisplayName,
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../utils/constant";
import { removeDeletedVideos } from "../../Redux/Actions/StorageManagementActions";
import {
  setDrawerOpen,
  setSchoolAdminProfileImage,
} from "../../Redux/Actions/SchoolAdminDashboardAction";
import { useSchoolDashboardMenuListHook } from "../../data/useSchoolDashboardMenuListHook";
import ResetPasswordDialog from "./Popups/ResetPasswordDialog";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: 1000,
    }),
  },
  drawerPaper: {
    width: drawerWidth,
    color: "#575757",
    zIndex: 11,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: 1000,
    }),
  },

  drawerContainer: {
    overflow: "auto",
  },
  dropdownbutton: {
    margin: theme.spacing(1),
    color: "#575757",
    borderRadius: "22px",
    width: "80%",
    fontFamily: "Rajdhani-SemiBold",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dropdown: {
    position: "absolute",
    right: 0,
    left: "8px",
    zIndex: 1,
    padding: theme.spacing(0, 1),
    // backgroundColor: '#003594',
    width: "80%",
    // top: '100px',
    color: "#575757",
    borderRadius: "22px",
    textAlign: "center",
    fontFamily: "Rajdhani-SemiBold",
  },
  innerdropdown: {
    color: "#575757",
    fontFamily: "Rajdhani-SemiBold",
    background: "#E0E0E0",
  },
  grow: {
    flexGrow: 1,
    textAlign: "right",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tabs: {
    // background: '#003594'
  },

  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const ProfileSection = (props) => {
  const [, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElog, setAnchorElog] = useState(null);
  const lolcation = useLocation();
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [schoolName, setschoolName] = useState(null);
  const [schoolLogoShow, setschoolLogoShow] = useState(null);
  const [opendialog, setOpendialog] = useState(false);
  const [coachId, setCoachId] = useState(null);
  const [schoolNo, setSchoolNo] = useState(null);
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [schoolId, setSchoolId] = useState(null);
  const [unReadCount, setUnReadCount] = useState(null);
  const [showBillingMsg, setShowBillingMsg] = useState("");
  const [shortBilingMsg, setShortBilingMsg] = useState("");
  const [billingMsgFlag, showBillingMsgFlag] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [errorPassword, setError] = useState("");
  const [errorPasswordLength, setErrorLength] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [assignedRights, setAssignedRights] = useState([]);
  const [manageList, setManageList] = useState();
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      profileImage: user.uploadedLogo
        ? user.uploadedLogo.filePath
        : blankProfile,
      userName: user.firstName + " " + user.lastName,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
    };
  });
  const { maxLibraryPage } = useSelector((state) => state?.videoLibraryData);
  const schoolAdminProfileImage = useSelector(
    (state) => state.schoolAdminDashboardInformation.url
  );
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.userProfile?.currentSeason?.years
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const classes = useStyles({ isDrawerOpen });

  const sidebarMenuList = useSchoolDashboardMenuListHook();
  const dispatch = useDispatch();

  const submitResetPassword = async (values, setSubmitting) => {
    setSubmitting(true);
    const { oldPassword, password, confirmPassword } = values;
    setOpenReset(false);
    userService
      .resetPasswordSuperAdmin(oldPassword, password, confirmPassword)
      .then((response) => {
        setSubmitting(false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Password changed successfully.",
            open: true,
          },
        });
        logout();
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something went wrong!",
        });
      });
    setSubmitting(false);
  };

  const handleClickSucess = () => {
    setOpenSuccess(true);
    setOpenReset(false);
  };

  const handleClickCloseSucess = () => {
    setOpenSuccess(false);
  };

  const [click, setClick] = React.useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  const menuId = "primary-search-account-menu";
  const textProfile = {
    color: "black",
    textAlign: "right",
  };
  const history = useHistory();

  const isMenuOpen = Boolean(anchorEl);
  const isMenuOpenNoti = Boolean(anchorElog);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileMenuOpen1 = (event) => {
    setAnchorElog(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuCloseNoti = () => {
    setAnchorElog(null);
  };
  const profile = () => {
    window.localStorage.clear();
    history.push("/profileManagement");
  };
  // for popup
  const openDialog = () => {
    setOpendialog(true);
  };
  const closeDialog = () => {
    setOpendialog(false);
  };

  const loadDataOnlyOnce = () => {
    userService
      .getCoachSchoolDetails(coachId)
      .then((response) => {
        var arr = response.data.data;
        if (arr !== null) {
          setSchoolDetails(arr.schools);
          setSchoolNo(arr.length);
        }
      })
      .catch((error) => {
        console.error("There was an error Solve!", error);
      });
  };

  const loadDataOnlyNotification = () => {
    setSubmitting(true);
    userService
      .getNotificationData()
      .then((response) => {
        var data = response.data.data;
        setUnReadCount(data.unreadCount);
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const handleClickToOpenReset = () => {
    setOpenReset(true);
  };

  const handleToCloseReset = () => {
    setOpenReset(false);
  };

  useEffect(() => {
    var UserName = getFromLocalStorage("loginUser");
    var adminRole = getFromLocalStorage("loginRole");
    var schoolLogoShow = getFromLocalStorage("schoolLogo");
    var coachId = getFromLocalStorage("coachId");
    var schoolId = getFromLocalStorage("schoolId");
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
    setUserName(UserName);
    setadminRole(adminRole);
    setschoolName(schoolName);
    setschoolLogoShow(schoolLogoShow);
    setCoachId(coachId);
    setSchoolId(schoolId);
    checkManagelist(adminRole);
  }, []);

  useEffect(() => {
    adminRole === "SCHOOL ADMIN" &&
      schoolId &&
      userService.getSchoolDetails(schoolId).then((res) => {
        const schoolAdminProfileUrl = res.data.data.user?.profileUrl?.filePath;
        setSchoolAdminProfileImage(
          dispatch,
          schoolAdminProfileUrl ? schoolAdminProfileUrl : ""
        );
      });
  }, [adminRole, schoolId]);

  const checkManagelist = (role) => {
    switch (role) {
      case "SCHOOL ADMIN":
        setManageList(schoolAdminList);

        break;

      case "COACH":
        setManageList(coachesList);
        break;

      case "ATHELETE":
        setManageList(athleteList);

        break;

      case "TEAM_ADMIN":
        setManageList(schoolAdminList);

      default:
        break;
    }
  };

  useEffect(() => {
    var schoolId = getFromLocalStorage("schoolId");
    var coachRole = getFromLocalStorage("loginRole");
    loadDataOnlyOnce();
    loadDataOnlyNotification();
    if (coachRole != "COACH" && coachRole != "ATHLETE") {
      getLiveDueDates(schoolId);
    }
  }, []);

  const currentRoute = useHistory().location.pathname.toLowerCase();

  const getLiveDueDates = (schoolId) => {
    userService
      .getBillingDetailsCheck(schoolId)
      .then((response) => {
        var msgCount1 = getFromLocalStorage("billingShowHideFlag");
        if (response.data.data == "" || response.data.data == null) {
          showBillingMsgFlag(false);
        } else {
          setShowBillingMsg(response.data.data.split(","));
          setShortBilingMsg(response.data.data.split(","));
          showBillingMsgFlag(true);
          setInToLocalStorage("billingShowHideFlag", true);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const closebillingMsgShow = () => {
    setShowBillingMsg("");
    showBillingMsgFlag(false);
  };

  const switchSchool = (id, name, logo) => {
    setSchoolId(id);
    setschoolName(name);
    setschoolLogoShow(logo);
    localStorage.setItem("schoolId", id);
    localStorage.setItem("schoolName", name);
    localStorage.setItem("schoolLogo", logo);
    window.location.reload();
  };

  function logout() {
    removeFromLocalStorage("user");
    removeFromLocalStorage("livestreamData");
    removeDeletedVideos(dispatch, {});
    window.localStorage.clear();
    history.push("/login");
  }
  const handleClickAway = () => {
    setOpen(false);
  };

  const [isOpen, setIsOpen] = useState(true);

  const setUnreadCountZero = () => {
    setUnReadCount(null);
  };

  const handleVideoStreamingClick = () => {
    if (
      assignedRights.includes("Record Video") ||
      adminRole == "SCHOOL ADMIN"
    ) {
      //It enable aws IVS streaming feature
      history.push("/videostreamingforschooladmin");
      //history.push("/realTimeStreaming");
    } else {
      openFailDialog(dispatch, {
        open: true,
        message:
          "You don't have permission to access Video Streaming, Please contact school admin.",
      });
    }
  };

  const renderMenu = (
    <Menu
      className="mt30"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {adminRole == "SCHOOL ADMIN" && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/pfmanagement" className="black profile-menu-barr">
            <FaUserCog className="profile-menu-iconss" />
            Profile Management
          </Link>
        </MenuItem>
      )}
      {adminRole == "TEAM_ADMIN" && (
        <MenuItem className="profile-menuu-barr">
          <Link
            to="/teamadminprofiledetails"
            className="black profile-menu-barr"
          >
            <FaUserCog className="profile-menu-iconss" />
            Manage Profile
          </Link>
        </MenuItem>
      )}
      {adminRole == "COACH" && adminRole != "ATHLETE" && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/coachprofile" className="black profile-menu-barr">
            <FaUser className="profile-menu-iconss" />
            Profile Management
          </Link>
        </MenuItem>
      )}
      {(adminRole === "SCHOOL ADMIN" || adminRole === "COACH") && (
        <MenuItem
          className="profile-menuu-barr"
          onClick={handleVideoStreamingClick}
        >
          <div className="black profile-menu-barr">
            <FaVideo className="profile-menu-iconss" />
            Video Streaming
          </div>
        </MenuItem>
      )}
      {(adminRole == "SCHOOL ADMIN" ||
        assignedRights.includes("Add / Remove Video Content")) && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/createvideohighlights" className="black profile-menu-barr">
            <FaCut className="profile-menu-iconss" />
            Create Highlight
          </Link>
        </MenuItem>
      )}
      {(adminRole == "SCHOOL ADMIN" ||
        assignedRights.includes("Add / Remove Video Content")) && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/storageManagement" className="black profile-menu-barr">
            <FaDatabase className="profile-menu-iconss" />
            Storage Management
          </Link>
        </MenuItem>
      )}
      {adminRole == "COACH" && adminRole != "ATHLETE" && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/pfmanagement" className="black profile-menu-barr">
            <FaSchool className="profile-menu-iconss" />
            School Details
          </Link>
        </MenuItem>
      )}

      {adminRole == "ATHLETE" && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/athleteprofiledetails" className="black profile-menu-barr">
            <FaUser className="profile-menu-iconss" />
            Profile Management
          </Link>
        </MenuItem>
      )}

      {(adminRole == "SCHOOL ADMIN" ||
        assignedRights.includes("View Invoices")) && (
        <MenuItem className="profile-menuu-barr">
          <Link to="/billingDetails" class="black profile-menu-barr">
            <FaRegEdit className="profile-menu-iconss" />
            Billing
          </Link>
          {billingMsgFlag && (
            <span className="warningbox fs-14 semibold ml-2 ">
              {shortBilingMsg[1]}
            </span>
          )}
        </MenuItem>
      )}

      <MenuItem onClick={handleClickToOpenReset} className="profile-menuu-barr">
        <div className="black profile-menu-barr">
          <FaKey className="profile-menu-iconss" />
          Reset Password
        </div>
      </MenuItem>

      <MenuItem onClick={logout} className="profile-menuu-barr">
        <div className="black profile-menu-barr">
          <FaPowerOff className="profile-menu-iconss" />
          Logout
        </div>
      </MenuItem>
    </Menu>
  );
  const renderMenuNew = (
    <Menu
      className=" mt30 "
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id="notificationList"
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpenNoti}
      onClose={handleMenuCloseNoti}
    >
      <NotificationContainer
        handleClick={setUnreadCountZero}
        notificationUnReadCount={unReadCount}
        setUnReadCount={setUnReadCount}
      />
    </Menu>
  );

  return (
    <div>
      <div className="nav-right d-flex">
        {(adminRole == "SCHOOL ADMIN" ||
          assignedRights.includes("Add / Remove Video Content")) &&
          currentSeason && (
            <div className="d-flex-center">
              <Link to="/uploadvideo">
                <img src={UploadIcon} alt="VL" className="uploadIcon" />
                <span className="link video-text noWrap card-box-style mobilehide">
                  Upload Video
                </span>
              </Link>
            </div>
          )}

        <IconButton
          aria-label="show 17 new notifications"
          color="inherit"
          onClick={handleProfileMenuOpen1}
        >
          <Badge badgeContent={unReadCount} color="secondary">
            <NotificationsNoneIcon />
          </Badge>
        </IconButton>
        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
          className="profile-btn"
        >
          <ListItem style={textProfile}>
            {/* <ListItemText
              id="textPro"
              style={{ textTransform: "capitalize" }}
              primary={userInfo.userName}
              secondary={userRoleDisplayName[userInfo.role]}
            /> */}
            <ListItemText
              id="textPro"
              style={{ textTransform: "capitalize" }}
              primary={userInfo.userName}
              secondary={userRoleDisplayName[userInfo.role]}
              secondaryTypographyProps={{
                style: { textAlign: "center", display: "block" },
              }}
            />
          </ListItem>
          <Avatar
            src={
              adminRole === "SCHOOL ADMIN"
                ? schoolAdminProfileImage
                  ? schoolAdminProfileImage
                  : blankProfile
                : userInfo?.profileImage
            }
          />
        </IconButton>
      </div>
      <div>
        {renderMenu} {renderMenuNew}
      </div>
      <ResetPasswordDialog
        submitResetPassword={submitResetPassword}
        openReset={openReset}
        handleToCloseReset={handleToCloseReset}
      />
    </div>
  );
};

export default ProfileSection;
